<div [id]="this.chartId" class="chart-wrapper"></div>
